import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Header from "@/components/layout/Header";
import LiveBanner from "@/components/layout/LiveBanner";
import StrategiesTab from "@/components/v2/StrategiesTab";
import WebhookSourcesTab from "@/components/v2/WebhookSourcesTab";
import PortfolioRulesTab from "@/components/v2/PortfolioRulesTab";
import ExecutionHistoryTab from "@/components/v2/ExecutionHistoryTab";
import PortfolioSnapshotsTab from "@/components/v2/PortfolioSnapshotsTab";

export default function V2Dashboard({ user }) {
  return (
    <div className="min-h-screen bg-surface-1 text-foreground">
      <LiveBanner />
      <Header user={user} />
      <main className="max-w-[1600px] mx-auto px-6 py-6 space-y-5">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2 pb-2">
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">
              / v2 management
            </div>
            <h1 className="text-2xl sm:text-3xl font-medium tracking-tight mt-1">
              Strategy Control Center
            </h1>
          </div>
        </div>

        <Tabs defaultValue="strategies" className="space-y-4">
          <TabsList className="bg-surface-2 border border-border">
            <TabsTrigger value="strategies">Strategies</TabsTrigger>
            <TabsTrigger value="webhooks">Webhook Sources</TabsTrigger>
            <TabsTrigger value="rules">Portfolio Rules</TabsTrigger>
            <TabsTrigger value="history">Execution History</TabsTrigger>
            <TabsTrigger value="snapshots">Snapshots</TabsTrigger>
          </TabsList>
          <TabsContent value="strategies" className="mt-0"><StrategiesTab /></TabsContent>
          <TabsContent value="webhooks" className="mt-0"><WebhookSourcesTab /></TabsContent>
          <TabsContent value="rules" className="mt-0"><PortfolioRulesTab /></TabsContent>
          <TabsContent value="history" className="mt-0"><ExecutionHistoryTab /></TabsContent>
          <TabsContent value="snapshots" className="mt-0"><PortfolioSnapshotsTab /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
